import React from 'react';
import './inventoryTypes.css';
import { connect } from 'react-redux';
import {
  updateSelectedInventoryType,
  updateInventoryTypeFilter
} from '../../../actions/adminActions/adminInventoryTypeActions';
import { inventoryType } from '../../../apis/backend';
import EditModal from './inventoryTypeModals/editModal.jsx';
import AddModal from './inventoryTypeModals/addModal.jsx';

class InventoryType extends React.Component {
  async objectDeleteRequest(id) {
    await inventoryType
      .delete(`/${id}`, {
        headers: { authorization: this.props.employeeToken }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  getLocation(locationId) {
    const location = this.props.systemLocations.find(
      (location) => location.id === locationId
    ).location;
    return `${location.charAt(0).toUpperCase()}${location.slice(1)}`;
  }

  renderInventory() {
    //renders the users table
    return (
      <>
        {this.props.inventoryTypes
          .filter((obj) => {
            const filterString = `${obj.name} ${this.getLocation(obj.location)} ${obj.price}`;
            return (
              filterString.toLowerCase().indexOf(this.props.inventoryTypeFilter.toLowerCase()) > -1
            );
          })
          .map((invent) => (
            <tr key={this.props.inventoryTypes.indexOf(invent)}>
              <td className="text-center" style={{ width: '5%' }}>
                {invent.name}
              </td>
              <td className="text-center" style={{ width: '15%' }}>
                ${invent.price.toFixed(2)}
              </td>
              <td className="text-center" style={{ width: '15%' }}>
                {this.getLocation(invent.location)}
              </td>
              <td className="text-center " style={{ width: '10%' }}>
                <div
                  data-target="#exampleModal"
                  className="btn btn-sm btn-dark"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedInventoryType(invent.id);
                  }}
                >
                  Edit
                </div>
              </td>
              <td className="text-center " style={{ width: '10%' }}>
                <div
                  className="btn btn-sm btn-dark"
                  data-target="#deleteModal"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedInventoryType(invent.id);
                  }}
                >
                  Remove
                </div>
              </td>
            </tr>
          ))}
      </>
    );
  }

  getInventoryTypeName() {
    const type = this.props.inventoryTypes.find(
      (obj) => obj.id === this.props.selectedInventoryType
    );

    return type ? type.name : '';
  }

  render() {
    return (
      <div className="users-page">
        <div className="container">
          <div
            className="form-inline md-form form-sm mt-4"
            style={{ fontSize: '36px', color: '#fff' }}
          >
            <div style={{ margin: 'auto', height: '48px', width: '100%' }}>Inventory Types</div>
          </div>
          <div className="form-inline md-form form-sm mt-3">
            <input
              value={this.props.inventoryTypeFilter}
              className="form-control form-control-lg w-45"
              type="text"
              placeholder="Search"
              aria-label="Search"
              onChange={(e) => {
                this.props.updateInventoryTypeFilter(e.target.value);
              }}
            />
            <div
              data-target="#addModal"
              className="btn btn-lg btn-dark"
              data-toggle="modal"
              style={{ marginLeft: '10px' }}
            >
              Add Inventory Type
            </div>
          </div>
          <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table className="table table-striped  table-bordered table-hover bg-white mt-1 mr-3">
              <thead className="bg-dark thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '15%' }}>
                    Item Type
                  </th>
                  <th className="text-center" style={{ width: '5%' }}>
                    Price
                  </th>
                  <th className="text-center" style={{ width: '15%' }}>
                    Facility
                  </th>
                  <th className="text-center" style={{ width: '5%' }}>
                    Edit
                  </th>
                  <th className="text-center" style={{ width: '5%' }}>
                    Remove
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderInventory()}</tbody>
            </table>
          </div>
        </div>

        <AddModal />

        <EditModal />

        <div className="modal fade" id="deleteModal" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ width: '80%', margin: '0 auto' }}>
              <div className="modal-header">
                <h5 className="modal-title">Are you Sure?</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.props.updateSelectedInventoryType(0);
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ textAlign: 'center', fontSize: '18px' }}>
                <strong>&apos;{this.getInventoryTypeName()}&apos;</strong> will be deleted forever!!
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.objectDeleteRequest(this.props.selectedInventoryType);
                    this.props.updateSelectedInventoryType(0);
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.props.updateSelectedInventoryType(0);
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  inventoryTypes: state.admin.admin.inventoryTypes,
  inventoryTypeFilter: state.admin.inventoryTypes.inventoryTypeFilter,
  selectedInventoryType: state.admin.inventoryTypes.selectedInventoryType,
  systemLocations: state.admin.admin.systemLocations,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, {
  updateSelectedInventoryType,
  updateInventoryTypeFilter
})(InventoryType);
